import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6f6fe531")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "phone"
}, "Cell phone", -1)
const _hoisted_4 = {
  key: 0,
  class: "col-12 col-md-4 mb-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "phone"
}, "Serial Number", -1)
const _hoisted_6 = ["disabled", "onChange"]
const _hoisted_7 = { class: "col-12 col-md-4 mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label d-none d-md-block" }, " ", -1)
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "col-12 col-md-4 mb-3"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label d-none d-md-block" }, " ", -1)
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = { class: "col-12 mb-3" }
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_15 = {
  key: 1,
  class: "alert alert-danger"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Form, {
      ref: "searchForm",
      "validation-schema": _ctx.validationSchema,
      autocomplete: "off",
      onSubmit: _ctx.onSubmit
    }, {
      default: _withCtx(({ errors, setFieldValue }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_Field, { name: "phone" }, {
              default: _withCtx(({ meta: m }) => [
                _createVNode(_component_InputMask, {
                  modelValue: _ctx.phoneMaskedValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.phoneMaskedValue = $event)),
                  class: _normalizeClass([m.valid === false && _ctx.isInvalid(errors, 'phone'), "form-control"]),
                  disabled: !_ctx.hasPermission,
                  unmask: true,
                  autocomplete: "noautocomplete",
                  mask: "(999) 999-9999",
                  type: "tel",
                  onChange: ($event: any) => (setFieldValue('phone', _ctx.phoneMaskedValue))
                }, null, 8, ["modelValue", "class", "disabled", "onChange"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_ErrorMessage, {
              class: "invalid-feedback",
              name: "phone"
            })
          ]),
          (!_ctx.isInjuredGadgets)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_Field, { name: "phone" }, {
                  default: _withCtx(({ meta: m }) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.serial_number = $event)),
                      class: _normalizeClass([m.valid === false && _ctx.isInvalid(errors, 'serial_number'), "form-control"]),
                      disabled: !_ctx.hasPermission,
                      autocomplete: "noautocomplete",
                      type: "text",
                      onChange: ($event: any) => (setFieldValue('serial_number', _ctx.serial_number))
                    }, null, 42, _hoisted_6), [
                      [_vModelText, _ctx.serial_number]
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ErrorMessage, {
                  class: "invalid-feedback",
                  name: "serial_number"
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("button", {
              disabled: !_ctx.hasPermission,
              class: "btn btn-fw btn-primary",
              type: "submit"
            }, " Search ", 8, _hoisted_9)
          ]),
          (_ctx.hasFiltered)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("button", {
                  disabled: !_ctx.hasPermission,
                  class: "btn btn-fw btn-outline-primary",
                  onClick: 
              () => {
                _ctx.onClear()
                setFieldValue('phone', '')
                setFieldValue('serial_number', '')
              }
            
                }, " Clear ", 8, _hoisted_12)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            (
              _ctx.endUserState.endUsersFilterQuantity === 0 &&
              _ctx.endUserState.endUsersQuantity > 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No user was found. Please verify that the filters are correct. After this, please try again "))
              : _createCommentVNode("", true),
            (
              _ctx.endUserState.endUsersFilterQuantity === 0 &&
              _ctx.endUserState.endUsersQuantity === 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No user was found. "))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema", "onSubmit"])
  ]))
}